import { useField } from 'formik';
import { InputLabel, useTheme } from '@mui/material';
import {
  GridContainer,
  GridItem,
  StyledTextInput
} from '../StyledComponents/Index';

function TextInput(props) {
  const {
    name,
    label,
    width = '100%',
    multiline,
    maxRows,
    InputLabelProps,
    InputProps,
    placeholder,
    component,
    ...rest
  } = props;
  const theme = useTheme();
  const [field, meta] = useField(name);

  const configTextfield = {
    ...field,
    ...rest,
    fullWidth: true,
    variant: 'outlined'
  };

  if (meta && meta.touched && meta.error) {
    configTextfield.error = true;
    configTextfield.helperText = meta.error;
  }

  return (
    <>
      <GridContainer rowSpacing={2}>
        <GridItem md={12}>
          <InputLabel className="input-label">{label}</InputLabel>
        </GridItem>
        <GridItem md={12}>
          <StyledTextInput
            {...configTextfield}
            multiline={multiline}
            maxRows={maxRows}
            InputLabelProps={InputLabelProps}
            component={component}
            placeholder={placeholder}
            InputProps={{
              ...InputProps,
              style: {
                fontFamily: 'Poppins',
                borderRadius: '12px',
                backgroundColor: theme.colors.alpha.trueWhite[100]
              }
            }}
            sx={{
              [theme.breakpoints.up('lg')]: {
                '& .MuiOutlinedInput-input': {
                  fontSize: '16px',
                  fontFamily: 'Poppins'
                }
              }
            }}
            fullWidth
          />
        </GridItem>
      </GridContainer>
    </>
  );
}

export default TextInput;
